import React from 'react'
import TreatmentCreate from '../treatment_components/treatmentCreate'
import { Card, CardContent, CardHeader } from '@mui/material'
import WebSidebar from '../../web_sidebar'
export default function
    () {
    return (
        <div>
            <div className='row'>

                <WebSidebar />


                <div className='content-wrapper w-75 bg-white p-5'>
                    <div>
                        <h2>Create Treatment</h2>
                        <TreatmentCreate />
                    </div>


                </div>
            </div>




        </div>
    )
}
